import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class EqualToValidationRule extends ValidationRule {
  private expectedValue: any;

  constructor(expectedValue: any, key: string) {
    if (!key) {
      key = ValidationTypes.equalTo;
    }

    super(key);

    this.expectedValue = expectedValue;
  }

  isValid(value: any): boolean {
    return value === this.expectedValue;
  }
}
